'use client';

import React from 'react';
import Image from 'next/image';
import { ImageData } from '@/components/home/sections/PortalGallery/ImageMarqueeBlock';

interface ImageMarqueeBlockElementProps {
  image: ImageData;
}

const ImageMarqueeBlockElement: React.FC<ImageMarqueeBlockElementProps> = ({ image }) => {
  return (
    <div className="relative flex h-[60px] w-fit flex-shrink-0 items-center">
      <Image
        src={image.url}
        alt={image.title}
        width={100}
        height={100}
        className="object-cover"
        style={{ filter: 'invert(60%) sepia(100%) saturate(2000%) hue-rotate(200deg) brightness(27%) contrast(100%)' }}
      />
    </div>
  );
};

export default ImageMarqueeBlockElement;
